import { protectedResources } from "../../authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

const getToken = (instance, account, inProgress) => {
  // Only proceed if an account is available and no authentication process is already in progress
  if (account && inProgress === "none") {
    return instance
      .acquireTokenSilent({
        scopes: protectedResources.apiHello.scopes, // Define the scopes you need
        account: account,
      })
      .then((response) => {
        // If silent acquisition is successful, return the access token
        return response.accessToken;
      })
      .catch((error) => {
        // If silent token acquisition fails, attempt interactive authentication using a popup
        if (error instanceof InteractionRequiredAuthError) {
          return instance
            .acquireTokenPopup({
              scopes: protectedResources.apiHello.scopes, // Define the scopes you need
            })
            .then((response) => {
              // If popup authentication is successful, return the access token
              return response.accessToken;
            })
            .catch((error) => {
              console.error("Interactive authentication failed", error);
              throw error; // You can choose to handle the error here if needed
            });
        } else {
          // If another error occurs, log and throw the error
          console.error("Token acquisition failed", error);
          throw error; // You can choose to handle the error here if needed
        }
      });
  } else {
    return new Promise((resolve, reject) => {
      reject("No account found or authentication already in progress");
    });
  }
};

export { getToken };
